import { isAnchor } from './domUtils';

export const findClosestAnchorNode = (node: Node, stop: Node = null) => {
    for (; node && node !== stop; node = node.parentNode) {
        if (isAnchor(node)) {
            return node;
        }
    }
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/anchor/findClosestAnchorNode.tsx